import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import Seal from "assets/morning/seal.png";
import Logo from "assets/logo/logo_morning.png";

interface Props {
    data: any;
    onClose: () => void;
}

const PrintBill = ({ data, onClose }: Props) => {
    return ReactDOM.createPortal(
        <div id="print-area" className="print-area px-16 ">
            <div className="flex justify-between gap-14 items-center mb-10 ">
                <div className="flex flex-col gap-2">
                    <img src={Logo} alt="logo" />
                    <p className="text-[26px] font-[600]">일신모닝택배운임영수</p>
                </div>
                <div className="p-5 border-4 border-[#ddd] w-[65%] relative flex flex-col gap-2 text-[17px] text-[#666]">
                    <p>
                        <span className="text-xl font-semibold text-black min-w-[120px] inline-block">택배운임영수</span> Tel.
                        {data?.전화번호}
                    </p>
                    <p>
                        <span className="text-xl font-semibold text-black min-w-[128px] inline-block">운송장번호</span>
                        {data?.운송장번호}
                    </p>
                    <p>
                        <span className="text-xl font-semibold text-black min-w-[126px] inline-block">접수일자</span>
                        {data?.접수일자}
                    </p>
                    <p>
                        <span className="text-xl font-semibold text-black min-w-[120px] inline-block">택배운임</span>{" "}
                        {data?.운임.toLocaleString()}
                    </p>
                    <img src={Seal} alt="Seal" className="fixed right-14 top-14 w-14 h-14" />
                </div>
            </div>
            <div className="flex flex-col mb-10">
                <p className="text-lg font-bold">발송 및 지불 방법</p>
                <hr className="my-3" />
                <div className="text-[17px] flex flex-col gap-3">
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">발송구분</p>
                        <p>{data?.발송구분}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">지불방법</p>
                        <p>{data?.지불방법}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">요금처</p>
                        <p>{data?.요금처}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">담당자</p>
                        <p>{data?.담당자}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">수량</p>
                        <p>{data?.수량.toLocaleString()}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col mb-10">
                <p className="text-lg font-bold">출발지 정보</p>
                <hr className="my-3" />
                <div className="text-[17px] flex flex-col gap-3">
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">상호</p>
                        <p>{data?.출발지상호}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">연락처</p>
                        <p>{data?.출발지연락처}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">담당자</p>
                        <p>{data?.출발지담당자}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">주소</p>
                        <p>{data?.출발지주소}</p>
                    </div>
                </div>
            </div>
            <div className="flex flex-col mb-0">
                <p className="text-lg font-bold">도착지 정보</p>
                <hr className="my-3" />
                <div className="text-[17px] flex flex-col gap-3">
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">상호</p>
                        <p>{data?.도착지상호}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">연락처</p>
                        <p>{data?.도착지연락처}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">담당자</p>
                        <p>{data?.도착지담당자}</p>
                    </div>
                    <div className="flex">
                        <p className="min-w-[160px] text-lg text-[#666]">주소</p>
                        <p>{data?.도착지주소}</p>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default PrintBill;
